export default "__VITE_ASSET__B1q7IC4U__"